<template>
  <StudioMultiSelect
    v-model="botsSelected"
    :searchable="true"
    :items="items"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @selectedItem="selectedItem"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{index}">
      <span
        v-if="index === 0"
        class="grey--text caption"
      >
        {{ botsSelected.length }} {{ filterMessage(botsSelected) }}
      </span>
    </template>

    <template v-slot:item="{item, attrs}">
      <SelectItemWithIcon
        :item="item"
        :item-attributes="attrs"
        @selected-item="selectedItem"
      />
    </template>
  </StudioMultiSelect>
</template>

<script>
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';
import SelectItemWithIcon from '@/components/filter/SelectItemWithIcon';
import filtersModel from '@/mixins/filters-model';

export default {
  name: 'BotFilter',
  components: {
    StudioMultiSelect,
    SelectItemWithIcon,
  },
  mixins: [
    filtersModel,
  ],
  props: {
    label: {
      type: String,
      default: 'Bot',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      selected: '',
    };
  },
  computed: {
    placeholder() {
      return this.$t('components.filters.BotFilter.placeholder');
    },
    botsSelected: {
      get() {
        const types = this.value?.value;
        if (!types || types[0] === 'All') {
          return [];
        }
        return this.value.value;
      },
      set(newValue) {
        let newBots = newValue;

        if (!newValue || newValue.length === 0) {
          return this.$emit('input', undefined);
        }

        if (newValue && newValue.length && newValue.every(value => typeof value === 'object')) {
          newBots = newValue.map(v => v && v.value);
        }

        this.$emit('input', {
          value: newBots,
        });
      },
    },
  },
  methods: {
    selectedItem({ value }) {
      const newValues = this.botsSelected.includes(value)
        ? this.botsSelected.filter(botValue => botValue !== value)
        : [...this.botsSelected, value];

      this.$emit('input', {
        value: newValues,
      });
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
